import { Host, h } from '@stencil/core';
export class AibaSelfieCompareResultsWrapper {
  constructor() {
    this.data = undefined;
    this.handlers = undefined;
    this.productDetail = undefined;
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleSelfieCompareResultsWillLoad) {
      let { productDetail, data } = await this.handlers.handleSelfieCompareResultsWillLoad(this.data);
      if (productDetail)
        this.productDetail = productDetail;
      if (data)
        this.data = data;
    }
  }
  async componentDidLoad() {
    this.handlers && this.handlers.handleSelfieCompareResultsDidLoad && (await this.handlers.handleSelfieCompareResultsDidLoad());
  }
  async handleClickHandler(event, element) {
    var _a;
    if (!element || !(element === null || element === void 0 ? void 0 : element.data) || !((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.handleClick)) {
      return;
    }
    const handlerName = element.data.handleClick;
    this.handlers && this.handlers[handlerName] && (await this.handlers[handlerName](event, element));
  }
  render() {
    return (h(Host, null, this.data &&
      this.data.elements &&
      this.data.elements.map((component) => {
        var _a;
        if (component && component['name'] === 'aiba-compare-slider-parent-wrapper') {
          return (h("div", { class: "aiba-compare-slider-wrapper" }, h("div", { class: "aiba-compare-slider-inner-wrapper loading" }, component &&
            component.data &&
            component.data.elements &&
            component.data.elements.map(innerComponent => {
              if (innerComponent && innerComponent['name'] === 'aiba-image') {
                return h("img", Object.assign({}, innerComponent.data));
              }
              if (innerComponent && innerComponent['name'] === 'aiba-compare-slider') {
                return h("aiba-compare-slider", { data: innerComponent['data'], handlers: this.handlers });
              }
            }))));
        }
        if (component && component['name'] === 'aiba-notification-label') {
          return (h("div", { class: "prompt_content-wrapper promptVisibility" }, (_a = component === null || component === void 0 ? void 0 : component.data) === null || _a === void 0 ? void 0 : _a.elements.map((item) => {
            if (item.name === 'aiba-label') {
              return h("aiba-label", Object.assign({}, item['data']));
            }
          })));
        }
        if (component && component['name'] === 'aiba-compare-alert-index') {
          return h("aiba-alert-with-index", { handlers: this.handlers });
        }
        if (component && component['name'] === 'aiba-product') {
          return h("aiba-product", Object.assign({}, component, { detail: this.productDetail, handlers: this.handlers }));
        }
        if (component['name'] === 'aiba-button') {
          return h("aiba-button", Object.assign({}, component.data, { handleClick: event => this.handleClickHandler(event, component ? component : '') }));
        }
      })));
  }
  static get is() { return "aiba-selfie-compare-results-wrapper"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-compare-results-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-compare-results-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "productDetail": {}
    };
  }
}
//# sourceMappingURL=aiba-selfie-compare-results-wrapper.js.map
